<script>
  export let data, onClick;

  function click() {
    onClick(data);
  }
</script>
<div class="filter-option" style="background: #ecedf3;">
    <span>{data.name}</span>
    <a class="filter-delete" on:click={click}>
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px" width="10px" height="10px" viewBox="0 0 357 357" style="enable-background:new 0 0 357 357;"
             xml:space="preserve">
            <polygon
                    points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon>
        </svg>
    </a>
</div>